<script>
  import Common from '../js/common.js';

  export let value;
  export let lang = undefined;
  export let admin;
</script>

<a href='./#/fields/{value.code}' class='field'>
  <div class='field-box'>
    <img class='field-box-image' src='img/static/field/{value.shortcut}.jpg' alt='{value.name.en} field photo'/>

    <div class='field-box-label'>
      <div class='field-box-label-text'> {value.name[lang]} </div>
    </div>

    {#if value.id}
      <div class='field-box-id'> {Common.addZeros(value.id)} </div>
    {/if}

    {#if admin && value.timestamp > Common.getDbDate() + Common.getDbTime()}
      <div class='field-box-disabled'>
        {Common.convertDbFullDate(value.timestamp)}
      </div>
    {/if}

    {#if value.slot === -1}
      <div class='field-box-disabled'/>
    {/if}
  </div>
</a>

<style>
  .field {
    text-decoration: none;

    color: inherit;
  }

  .field-box {
    position: relative;

    display: flex;
    gap: 15px;

    padding: 15px;

    border-radius: var(--radius-lg);

    background: var(--grey-1);

    transition: box-shadow 1s ease-in-out, transform 1s ease-in-out;
  }

  .field-box:hover {
    box-shadow: 0px 0px 10px 0px var(--grey-4);

    transform: scale(1.025);
  }

  .field-box-image {
    flex-shrink: 0;

    width: 80px;
    height: 60px;

    border-radius: var(--radius-lg);

    object-fit: cover;
  }

  .field-box-label {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;

    font-weight: 550;
  }

  .field-box-label-text {
    text-align: center;
  }

  .field-box-id {
    position: absolute;
    bottom: 15px;
    right: 15px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 15px;
    height: 15px;

    font-family: 'JetBrains Mono';
    font-size: 12px;
    font-weight: 550;

    color: var(--grey-5);
  }

  .field-box-disabled {
    position: absolute;
    top: 0px;
    left: 0px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;

    border-radius: var(--radius-lg);

    font-family: 'JetBrains Mono';
    font-weight: bold;

    background: rgba(255, 255, 255, 0.75);
  }

  :global(body.dark) .field-box {
    background: var(--grey-8);
  }

  :global(body.dark) .field-box:hover {
    box-shadow: 0px 0px 10px 0px var(--black);
  }

  :global(body.dark) .field-box-image {
    filter: brightness(88%);
  }

  :global(body.dark) .field-box-id {
    color: var(--grey-6);
  }

  :global(body.dark) .field-box-disabled {
    background: rgba(33, 33, 33, 0.75);
  }
</style>
